import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ValidationsService } from '../../services/common/validations.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.scss']
})
export class OrganizationDetailsComponent implements OnInit {

  isLoading = true;

  organizationDetailsForm: FormGroup;
  isOrganizationDetailsFormSubmitted: boolean;

  saveBtnLabel = 'Saved';

  constructor(private formBuilder: FormBuilder, private validationService: ValidationsService, private dashboardService: DashboardService) { }

  ngOnInit() {

    this.organizationDetailsForm = this.formBuilder.group({
      orgnization_name: [''],
      helpline_number: [''],
      official_email_id: ['', this.validationService.validateEmail],
      office_address: [''],
      google_map_link: ['']
    });

    this.getOrganizationDetails();
  }

  // getters
  // get organization() { return this.organizationDetailsForm.get('organization'); }
  get official_email_id() { return this.organizationDetailsForm.get('official_email_id'); }

  // phone no.
  onlyNumericInput(event) {
    return this.validationService.isNumericInput(event);
  }

  getOrganizationDetails() {
    this.isLoading = true;

    this.dashboardService.getOrganizationDetails().subscribe(response => {
      this.isLoading = false;
      if (response.statusCode == 200 && response.status == false) {
        console.log('no data');
      }
      else if (response.statusCode == 200 && response.status == true) {
        this.organizationDetailsForm.patchValue({
          orgnization_name: response.data.orgnization_name,
          helpline_number: response.data.helpline_number,
          official_email_id: response.data.official_email_id,
          office_address: response.data.office_address,
          google_map_link: response.data.google_map_link
        });
      }
    });
  }


  organizationDetailsFormSubmit() {

    if (this.organizationDetailsForm.invalid) {
      return;
    }

    this.saveBtnLabel = 'Saving...';

    this.dashboardService.setOrganizationDetails(this.organizationDetailsForm.value).subscribe(response => {
      if (response.statusCode == 500 && response.status == false) {

      }
      else {
        this.saveBtnLabel = 'Saved';
      }
    });
    // write below aline after success form submit
    //this.organizationDetailsForm.reset();

    // this.isOrganizationDetailsFormSubmitted = true;

    // if (this.organizationDetailsForm.invalid) {
    //   return;
    // }
  }

  resetFlag() {
    this.saveBtnLabel = 'Save Changes';
  }

}
